import React from 'react';
import PropTypes from 'prop-types';
import Currency from 'react-currency-formatter';

const AccessoriesItem = ({ item, changeCheck, price }) => {
  const findItem = price.accessories.forFree.free.find(el => el.slug === item.slug);
  const itemPrice = findItem
    ? {
        actual: 0,
        regular: 0,
      }
    : item.price;
  return (
    <div className="accessories-list">
      <div className="accessories-list__box" title={item.safo}>
        <button
          onClick={changeCheck}
          className={`accessories-list__check-button ${item.check ? 'active' : ''}`}>
          <span className="icon-checkmark" />
        </button>
        <img className="accessories-list__img" src={item.icon} alt={item.name} />
        <span className="accessories-list__item">{item.name}</span>
      </div>
      <div className="accessories-list__pricing">
        <span className="accessories-list__pricing accessories-list__pricing--price">
          <Currency quantity={itemPrice.actual} currency="PLN" />
        </span>
        {itemPrice.actual < itemPrice.regular && (
          <span className="accessories-list__pricing accessories-list__pricing--del">
            <del>
              <Currency quantity={itemPrice.regular} currency="PLN" />
            </del>
          </span>
        )}
      </div>
    </div>
  );
};

AccessoriesItem.propTypes = {
  item: PropTypes.object,
  changeCheck: PropTypes.func,
  price: PropTypes.object,
};

export default AccessoriesItem;
